export default __webpack_public_path__ + "static/web-view-3324f2d60a527172f01550b588f96266.webp";